module.exports = __webpack_public_path__ + "img/68.c045f8c2.jpg";